var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"inline-block m_580:hidden",attrs:{"href":_vm.link}},[_c('img',{staticClass:"w-full",attrs:{"src":"https://placehold.co/600x400/bd6609/FFFFFF/png","alt":"","width":"600","height":"400","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }